import { render, staticRenderFns } from "./keyboard.vue?vue&type=template&id=53138e92&scoped=true&"
import script from "./keyboard.vue?vue&type=script&lang=js&"
export * from "./keyboard.vue?vue&type=script&lang=js&"
import style0 from "./keyboard.vue?vue&type=style&index=0&id=53138e92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53138e92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/apple/Desktop/linebot-backend.hciot.com.tw/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53138e92')) {
      api.createRecord('53138e92', component.options)
    } else {
      api.reload('53138e92', component.options)
    }
    module.hot.accept("./keyboard.vue?vue&type=template&id=53138e92&scoped=true&", function () {
      api.rerender('53138e92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/charts/keyboard.vue"
export default component.exports